import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/landing';
export function Bonuses() {
  return <section className="pegboard w-full py-20 md:py-28" aria-labelledby="bonus-title" data-id="element-28" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-6xl px-5" data-id="element-29" data-mp="au1usomoiijf">
        <div className="mx-auto max-w-3xl text-center" data-id="element-30" data-mp="at8w8axvizcd">
          <span className="inline-flex items-center gap-2 rounded-full bg-blush px-4 py-1.5 font-display font-semibold text-berry" data-id="element-31" data-mp="ft4rnlsi9igb">
            <GiftIcon className="h-4 w-4" aria-hidden data-id="element-32" data-mp="1whqt7xfm854" />
            Today only
          </span>
          <h2 id="bonus-title" className="mt-5 font-display text-3xl font-bold leading-tight text-ink md:text-5xl" data-id="element-33" data-mp="5xbcdunejauu">
            Plus, you get 3 exclusive bonuses — free
          </h2>
          <p className="mt-3 text-lg font-semibold text-inkSoft" data-id="element-34" data-mp="3t182dsuzig5g">$59 of extra activities, included with your library.</p>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-id="element-35" data-mp="1m8fav7b6xtow">
          {bonuses.map(b => <article key={b.title} className="flex flex-col overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-36" data-mp="1r6z31pgdo1pp">
              <div className="relative" data-id="element-37" data-mp="3dfd1bg2wlura">
                <img src={b.image} alt={`${b.title} cover`} className="aspect-square w-full object-cover" data-id="element-38" data-mp="3dea9n5xrboab" />
                <span className="absolute left-4 top-4 rounded-full bg-white px-3 py-1 text-sm font-extrabold text-teal shadow-soft" data-id="element-39" data-mp="3r5gl80eb9cdk">{b.tag}</span>
              </div>
              <div className="flex flex-1 flex-col p-6 text-center" data-id="element-40" data-mp="2zf2b8f9f4k76">
                <h3 className="font-display text-2xl font-bold leading-tight text-ink" data-id="element-41" data-mp="2zhezfa5rrqso">{b.title}</h3>
                <p className="mt-3 text-base leading-relaxed text-inkSoft" data-id="element-42" data-mp="2uitx956yix1l">{b.text}</p>
                <div className="mt-auto flex items-center justify-center gap-3 border-t border-line pt-5" data-id="element-43" data-mp="38e5upkchz1m7">
                  <span className="text-lg font-bold text-inkSoft line-through" data-id="element-44" data-mp="33jid85fwv7h4">{b.price}</span>
                  <span className="rounded-full bg-teal px-4 py-1 font-display text-lg font-bold text-white" data-id="element-45" data-mp="nruj0hsa7t20">FREE</span>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}